import { render, staticRenderFns, recyclableRender, components } from "./calendar-item.vue?vue&type=template&id=39ec3f8e&scoped=true&"
var renderjs
import script from "./calendar-item.vue?vue&type=script&lang=js&"
export * from "./calendar-item.vue?vue&type=script&lang=js&"
import style0 from "./calendar-item.vue?vue&type=style&index=0&id=39ec3f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec3f8e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-datetime-picker/components/uni-datetime-picker/calendar-item.vue"
export default component.exports